module.exports = __webpack_public_path__ + "img/36.4bc3ba4e.jpg";